import {
    ADD_NEW_CATEGORY_SET_MESSAGE,
    ADD_NEW_CATEGORY_RESET_TO_INITIAL
} from './AddNewCategoryModal.actions';

function addNewCategoryModal(state = null, action) {

    switch (action.type) {
        case ADD_NEW_CATEGORY_RESET_TO_INITIAL:
            return Object.assign({
                validationMessage: ''
            });

        case ADD_NEW_CATEGORY_SET_MESSAGE:
            return Object.assign(
                {}, state, {
                    validationMessage: action.payload
                }
            );

        default:
            return state;

    }

}

export default addNewCategoryModal;


// WEBPACK FOOTER //
// ./src/scripts/reusable/ReusableModals/AddNewCategoryModal/AddNewCategoryModal.reducers.js